import { Button, SearchField, SegmentedTabs } from '@skupreme/shared/ui';
import type { CartonKind } from '../lib/rows';
import { BulkUploadButton } from './BulkUploadButton';

export type CartonActionsProps = {
  kind: CartonKind;
  onKindChange: (kind: CartonKind) => void;
  search: string;
  onSearch: (search: string) => void;
  onBulkUpload: () => void;
  /** Entities edited and not saved yet. */
  changedCount: number;
  isSaving?: boolean;
  onCancel: () => void;
  onSave: () => void;
};

const KINDS = [
  { id: 'items', label: 'Items' },
  { id: 'components', label: 'Components' },
];

/** Items or components, search, bulk upload and saving edits: on the tabs' row. */
export function CartonActions({
  kind,
  onKindChange,
  search,
  onSearch,
  onBulkUpload,
  changedCount,
  isSaving,
  onCancel,
  onSave,
}: CartonActionsProps) {
  return (
    <>
      {changedCount ? (
        <span className="sk:inline-flex sk:items-center sk:gap-1.5">
          <span role="status" className="sk:text-xs sk:text-fg-secondary">
            Changes to {changedCount} item(s)
          </span>
          <Button
            variant="ghost"
            size="md"
            onPress={onCancel}
            isDisabled={isSaving}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="md"
            onPress={onSave}
            isPending={isSaving}
          >
            Save
          </Button>
        </span>
      ) : null}
      <SegmentedTabs
        label="Carton configuration of"
        items={KINDS}
        selectedKey={kind}
        onSelectionChange={key => onKindChange(key as CartonKind)}
      />
      {kind === 'items' ? <BulkUploadButton onUpload={onBulkUpload} /> : null}
      <SearchField
        aria-label="Search"
        placeholder="SKU, UPC, Title, ASIN..."
        value={search}
        onChange={onSearch}
        className="sk:w-64"
      />
    </>
  );
}
